<!--  -->
<template>
  <div v-loading="loadingtable" class="tactics_box">
    <el-form label-position="top" label-width="150px">
      <el-divider content-position="left">基本信息</el-divider>
      <div class="basic-box">
        <el-form-item v-if="type === 3" label="复用绑定关系">
          <el-radio-group v-model="reuse">
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="2">否</el-radio-button>
          </el-radio-group>
          <span style="margin-left: 200px">复用</span>
        </el-form-item>
        <div style="display:flex;">
          <el-form-item label="策略标题">
            <el-input v-model="sp_strategy_title" placeholder="请输入策略标题" class="stra_box" style="width:402px" />
          </el-form-item>
          <el-form-item label="策略类型">
            <el-radio-group v-model="sp_strategy_type" @change="spchanger">
              <el-radio-button :label="1" :disabled="type === 2 || type === 3">欢迎语</el-radio-button>
              <el-radio-button :label="2" :disabled="type === 2 || type === 3">定时</el-radio-button>
              <!-- <el-radio-button :label="3">循环</el-radio-button> -->
              <el-radio-button :label="4" :disabled="type === 2 || type === 3">关键词</el-radio-button>
              <el-radio-button :label="5" :disabled="type === 2 || type === 3">延时</el-radio-button>
              <el-radio-button :label="6" :disabled="type === 2 || type === 3">群欢迎语</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item v-if="sp_strategy_type != 1 && sp_strategy_type != 5 && sp_strategy_type != 6" label="发送对象类型 ">
          <el-radio-group v-model="group_selection" @change="sendmatgser">
            <el-radio-button :label="1" :disabled="type === 2">默认客户</el-radio-button>
            <!-- <el-radio-button :label="2" :disabled="type === 2">从群中选择</el-radio-button> -->
            <!-- <el-radio-button :label="2" disabled>从群中选择</el-radio-button> -->
            <el-radio-button :label="3" :disabled="type === 2">设置群</el-radio-button>
            <el-radio-button :label="4" :disabled="type === 2 || sp_strategy_type === 4">官方群</el-radio-button>
            <el-radio-button v-if="sp_strategy_type != 4" :label="5" :disabled="type === 2">拉群规则</el-radio-button>
            <el-radio-button :label="6" :disabled="type === 2">发言人群</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <div style="display:flex;">
          <el-form-item
            v-if="sp_strategy_type === 2 || sp_strategy_type === 4 || sp_strategy_type === 5 || sp_strategy_type === 6"
            label="发送方式"
          >
            <el-radio-group v-model="push_method" @change="spchangerr">
              <!-- || sp_strategy_type === 5 -->
              <el-radio
                :label="1"
                :disabled="sp_strategy_type === 4 || type === 2 || group_selection === 3 || group_selection === 5 || sp_strategy_type === 6"
              >
                官方接口
              </el-radio>
              <!-- || group_selection === 4 -->
              <el-radio :label="2" :disabled="type === 2 || group_selection === 4 || (sp_strategy_type === 2 && group_selection === 6)">
                第三方接口
              </el-radio>
              <!-- <el-radio :label="4" :disabled="type === 2">
                webflow
              </el-radio> -->
              <!-- <el-radio :label="3" :disabled="sp_strategy_type != 2 || group_selection != 1">自动化脚本</el-radio> -->
            </el-radio-group>
          </el-form-item>

          <el-form-item label="触发方式">
            <el-radio-group v-model="trigger_way">
              <el-radio :label="1" :disabled="push_method === 1 && sp_strategy_type === 5">默认</el-radio>
              <!-- sp_strategy_type === 5 ||   (push_method === 2 && sp_strategy_type != 5)-->
              <el-radio :label="2" :disabled="sp_strategy_type === 1 || sp_strategy_type === 4 || sp_strategy_type === 6 || (push_method === 2 && sp_strategy_type === 5)">
                企微脚本
              </el-radio>
            </el-radio-group>
          </el-form-item>

        </div>
        <div style="display:flex;">
          <el-form-item v-if="sp_strategy_type != 1 && sp_strategy_type != 4 && sp_strategy_type != 5 && sp_strategy_type != 6" label="关注时间">
            <el-select v-model="subscribe_time_type" placeholder="请选择" style="width:402px">
              <el-option v-for="item in optionsrr" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <span v-if="subscribe_time_type === 7" style="margin-left: 10px">
              <el-date-picker
                v-model="subscribetime"
                style="width: 400px"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                :default-time="['00:00:00', '23:59:59']"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :clearable="false"
                @change="timechanger"
              />
            </span>
          </el-form-item>
          <el-form-item v-if="sp_strategy_type != 1 && sp_strategy_type != 4 && sp_strategy_type != 5 && sp_strategy_type != 6" label="付费情况">
            <el-select v-model="consumption" placeholder="请选择付费情况" style="width:402px">
              <el-option v-for="item in optionspay" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </div>
        <!-- 新增定时参数，仅在满足条件时显示 -->
        <div
          v-if="
            sp_strategy_type === 2 &&
              push_method === 2 &&
              trigger_way === 2 &&
              (group_selection === 1 ||
                group_selection === 3 ||
                group_selection === 5)
          "
        >
          <div class="adds-box">
            <el-form-item label="单次时间间隔">
              <el-input-number
                v-model="timing_interval"
                :min="0"
                :max="100"
                style="width: 30%"
              />
            </el-form-item>
            <el-form-item label="最小动作时间间隔">
              <el-input-number
                v-model="act_interval_min"
                :min="0"
                :max="100"
                style="width: 30%"
              />
            </el-form-item>
          </div>
          <div class="adds-box">
            <el-form-item label="最大动作时间间隔">
              <el-input-number
                v-model="act_interval_max"
                :min="0"
                :max="100"
                style="width: 30%"
              />
            </el-form-item>
            <el-form-item label="批次数量">
              <el-input-number
                v-model="batch_size"
                :min="1"
                :max="100"
                style="width: 30%"
              />
            </el-form-item>
          </div>
          <div class="adds-box">
            <el-form-item label="企微脚本定时发送方式">
              <el-select v-model="script_send_way" placeholder="请选择发送方式">
                <el-option label="转发" :value="1" />
                <el-option label="H5应用" :value="2" />
              </el-select>
            </el-form-item>
          </div>

        </div>
      </div>
      <el-divider content-position="left">消息管理</el-divider>
      <div class="message-box">
        <div v-for="(item, index) in msg_data" :key="index" style="margin-bottom: 50px">

          <div v-if="sp_strategy_type === 2" class="copy_box">
            <div v-if="sp_strategy_type === 2 || sp_strategy_type === 4 || sp_strategy_type === 5" class="copy_box">
              <div>
                <div class="ca_boxr">第{{ index + 1 }}条</div>
              </div>
            </div>
            <div class="ca_boxre">时长:</div>
            <el-select v-if="sp_strategy_type === 2" v-model="item.cycle_type" placeholder="请选择时长类型" style="margin-right: 10px" @change="implement(item)">
              <el-option v-for="itemr in cycle" :key="itemr.value" :label="itemr.label" :value="itemr.value" />
            </el-select>
            <!-- <div v-if="sp_strategy_type === 3" class="taewr" style="margin-right:10px">
              <div class="tiwmeboxr">第</div>
              <el-input v-model="item.day_numbers" type="number" style="width:80px" @blur="timedayewr(index)" />
              <div class="tiwmebox">天</div>
            </div> -->
            <div v-if="item.cycle_type === 2 && sp_strategy_type === 2" class="taewr" style="margin-right: 10px">
              <el-select v-model="item.day_of_week" placeholder="请选择星期" style="width: 130px">
                <el-option v-for="itemr in weekarr" :key="itemr.value" :label="itemr.label" :value="itemr.value" />
              </el-select>
            </div>
            <div v-if="item.cycle_type === 3 && sp_strategy_type === 2" class="taewr" style="margin-right: 10px">
              <el-input v-model="item.day_of_month" type="number" style="width: 80px" @blur="dayewr(index)" />
              <div class="tiwmebox">日</div>
            </div>
            <div class="taewr" style="margin-right: 10px">
              <el-select v-model="item.hour" filterable placeholder="请选择" style="width: 90px">
                <el-option v-for="items in houroptions" :key="items.value" :label="items.label" :value="items.value" />
              </el-select>
              <div class="tiwmebox">时</div>
            </div>
            <div class="taewr" style="margin-right: 10px">
              <el-select v-model="item.minute" filterable placeholder="请选择" style="width: 90px">
                <el-option v-for="items in minutesoptions" :key="items.value" :label="items.label" :value="items.value" />
              </el-select>
              <div class="tiwmebox">分</div>
            </div>
            <img v-if="msg_data.length != 1" src="../../assets/svg/Delete-five.png" alt="My Icon" style="width:20px;height:20px;cursor:pointer;" @click="deleter(index)">
          </div>
          <div v-if="sp_strategy_type === 4" class="copy_box">
            <div>
              <div style="margin-top: 2px;" class="ca_boxr">第{{ index + 1 }}条</div>
            </div>
            <div>
              <div class="ca_boxre">关键词</div>
            </div>
            <div style="margin-right: 10px;">
              <el-input v-model.trim="item.keyword" placeholder="请输入关键字" />
            </div>
            <img v-if="msg_data.length != 1" src="../../assets/svg/Delete-five.png" alt="My Icon" style="width:20px;height:20px;cursor:pointer;" @click="deleter(index)">
          </div>
          <div v-if="sp_strategy_type === 5" class="copy_box">
            <div style="margin-right: 10px;">
              <div style="margin-top: 2px;" class="ca_boxr">第{{ index + 1 }}条</div>
            </div>
            <div>
              <div class="ca_boxre" style="width: 57px">延时时间</div>
            </div>
            <div class="senadtime">
              <div class="taewr" style="margin-right: 10px">
                <el-select v-model="item.hours" filterable placeholder="请选择" style="width: 90px">
                  <el-option v-for="items in houroptions" :key="items.value" :label="items.label" :value="items.value" />
                </el-select>
                <div class="tiwmebox">时</div>
              </div>
              <div class="taewr" style="margin-right: 10px">
                <el-select v-model="item.minutes" filterable placeholder="请选择" style="width: 90px">
                  <el-option v-for="items in minutesoptions" :key="items.value" :label="items.label" :value="items.value" />
                </el-select>
                <div class="tiwmebox">分</div>
              </div>
              <div class="taewr" style="margin-right: 10px">
                <el-select v-model="item.seconds" filterable placeholder="请选择" style="width: 90px">
                  <el-option v-for="items in minutesoptions" :key="items.value" :label="items.label" :value="items.value" />
                </el-select>
                <div class="tiwmebox">秒</div>
              </div>
            </div>
            <img v-if="msg_data.length != 1" src="../../assets/svg/Delete-five.png" alt="My Icon" style="width:20px;height:20px;cursor:pointer;" @click="deleter(index)">
          </div>
          <div v-if="sp_strategy_type === 5" class="copy_box">
            <div>
              <div class="ca_boxre" style="width: 57px">延时动作</div>
            </div>
            <div>
              <el-select v-model="item.delay_type" placeholder="请选择延时动作" @change="delayecahegr($event, item)">
                <el-option v-for="itemr in delayedarr" :key="itemr.value" :label="itemr.label" :value="itemr.value" />
              </el-select>
            </div>
          </div>
          <div v-if="sp_strategy_type === 5 && item.delay_type === 2" class="copy_box">
            <div>
              <div class="ca_boxre" style="width: 57px">关键字</div>
            </div>
            <div>
              <el-input v-model.trim="item.delay_keyword" placeholder="请输入关键字" />
            </div>
          </div>
          <div v-if="sp_strategy_type === 2 || sp_strategy_type === 4 || sp_strategy_type === 5" class="copy_box">
            <div>
              <div class="ca_boxre" style="margin-left:50px;">消息:</div>
            </div>
            <div>
              <el-tag v-if="item.sp_message_no != ''" style="margin-right: 10px">{{ item.message_name }} ( {{ item.sp_message_no }} )</el-tag>
              <!-- v-if="push_method != 1 || type != 2" -->
              <el-button plain size="mini" type="success" icon="el-icon-chat-dot-square" @click="chooser(index)">选择消息</el-button>
              <el-button plain size="mini" type="primary" icon="el-icon-copy-document" @click="copyReuse(item, index)">复用</el-button>
              <el-button v-if="item.sp_message_no != ''" plain size="mini" type="primary" icon="el-icon-pie-chart" @click="look(item.sp_message_no)">预览</el-button>
            </div>
          </div>
        </div>
        <div v-if="sp_strategy_type === 1 || sp_strategy_type === 6" class="copy_box">
          <div>
            <div class="ca_boxre">消息</div>
          </div>
          <div>
            <el-tag v-if="msg_data[0].sp_message_no != ''" style="margin-right: 10px">{{ msg_data[0].message_name }} ( {{ msg_data[0].sp_message_no }} )</el-tag>
            <!-- v-if="push_method != 1 || type != 2" -->
            <el-button size="mini" type="warning" icon="el-icon-s-promotion" @click="chooser(0)">选择消息</el-button>
            <el-button v-if="msg_data[0].sp_message_no != ''" size="mini" type="primary" icon="el-icon-pie-chart" @click="look(msg_data[0].sp_message_no)">预览</el-button>
          </div>
        </div>
        <!-- <el-button v-if="(sp_strategy_type === 2 || sp_strategy_type === 4 || sp_strategy_type === 5) && (push_method != 1 || type != 2)" size="mini" icon="el-icon-document-copy" type="primary" style="margin-left:57px" @click="copy">新增消息</el-button> -->
        <el-button v-if="sp_strategy_type === 2 || sp_strategy_type === 4 || sp_strategy_type === 5" size="mini" icon="el-icon-document-add" type="primary" class="add-btn" plain @click="copy">新增消息</el-button>
      </div>
      <div v-if="sp_strategy_type === 3" style="margin-left: 33px">
        <div v-for="(item, index) in cemsg_data" :key="index" style="margin-bottom: 80px">
          <div class="copy_box" style="padding-left: 0px">
            <div>
              <div class="ca_boxr">第{{ index + 1 }}条</div>
            </div>
            <div class="copy_boxr">
              <img v-if="cemsg_data.length != 1" src="../../assets/svg/Delete-five.png" alt="My Icon" style="width:20px;height:20px;cursor:pointer;" @click="deleterr(index)">
            </div>
          </div>
          <div class="copy_boxr" style="margin-bottom: 20px">
            <div class="ca_boxre">天数</div>
            <div class="taewr">
              <el-input v-model="item.day_numbers" type="number" style="width: 80px" />
              <div class="tiwmebox">天</div>
            </div>
          </div>
          <div class="caserr_box">
            <div v-for="(itemsr, indexr) in item.messages" :key="indexr">
              <div class="copy_boxr" style="margin-bottom: 20px">
                <div class="ca_boxre">时间</div>
                <div class="taewr" style="margin-right: 10px">
                  <el-select v-model="itemsr.hour" filterable placeholder="请选择" style="width: 90px">
                    <el-option v-for="items in houroptions" :key="items.value" :label="items.label" :value="items.value" />
                  </el-select>
                  <div class="tiwmebox">时</div>
                </div>
                <div class="taewr" style="margin-right: 10px">
                  <el-select v-model="itemsr.minute" filterable placeholder="请选择" style="width: 90px">
                    <el-option v-for="items in minutesoptions" :key="items.value" :label="items.label" :value="items.value" />
                  </el-select>
                  <div class="tiwmebox">分</div>
                </div>
                <img v-if="item.messages.length !== 1" src="../../assets/svg/Delete-five.png" alt="My Icon" style="width:20px;height:20px;cursor:pointer;" @click="deletercirculate(index, indexr)">
                <!-- <el-button v-if="indexr === 0" size="mini" icon="el-icon-document-copy" type="primary" @click="addmdssagecirculate(index)">新增消息</el-button> -->
              </div>
              <div class="copy_boxr" style="margin-bottom: 20px">
                <div class="ca_boxre">消息</div>
                <div>
                  <el-tag v-if="itemsr.sp_message_no != ''" style="margin-right: 10px">{{ itemsr.title }} ( {{ itemsr.sp_message_no }} )</el-tag>
                  <el-button size="mini" type="warning" icon="el-icon-s-promotion" @click="chooserr(index, indexr)">选择消息</el-button>
                  <el-button v-if="itemsr.sp_message_no != ''" size="mini" type="primary" icon="el-icon-pie-chart" @click="look(itemsr.sp_message_no)">预览</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-button v-if="sp_strategy_type === 3" size="mini" icon="el-icon-document-copy" type="primary" style="margin-left: 65px" @click="copycirculate">新增循环消息</el-button>
    </el-form>
    <div class="sava_box">
      <el-button type="info" @click="goback">返回</el-button>
      <el-button type="primary" :disabled="loadingtable" @click="saveclick">确定</el-button>
    </div>
    <el-dialog title="选择" :visible.sync="dialogVisible" :close-on-click-modal="false" :destroy-on-close="true" width="55%">
      <choosetactics ref="choosetacticsview" @callback="callback" @callbackr="callbackr" />
    </el-dialog>
    <!-- 预览标签组弹窗 -->
    <el-dialog title="预览" :close-on-click-modal="false" :visible.sync="priwdialogVisible" :modal-append-to-body="false" :append-to-body="true" width="25%">
      <previewdialog ref="timepreview" />
    </el-dialog>
  </div>
</template>

<script>
import choosetactics from './components/choosetactics.vue'
import { sprstrategystore, sprstrategystrategyInfo, sprstrategyupdate, sprEnterprise } from '@/api/officialaccount.js'
import previewdialog from '../enterpmessagelist/components/previewdialog.vue'
export default {
  components: { choosetactics, previewdialog },
  data() {
    return {
      dialogVisible: false,
      sp_strategy_type: 1,
      sp_strategy_title: '',
      group_selection: 1,
      priwdialogVisible: false,
      push_method: 1,
      msg_data: [
        {
          cycle_type: null, // 时长类型
          day_of_month: '', // 几日
          day_of_week: null, // 每星期
          sp_message_no: '', // 选择的消息
          message_name: '', // 选择的消息名称
          hour: '', // 小时
          minute: '', // 分钟
          day_numbers: '', // 第几天
          keyword: '', // 关键词
          hours: '', // 延时小时
          minutes: '', // 延时分钟
          seconds: '', // 延时描述
          delay_type: null, // 延时类型
          delay_keyword: '' // 延时关键字
        }
      ],
      cemsg_data: [
        {
          day_numbers: '',
          messages: [
            {
              sp_message_no: '',
              title: '',
              cycle_type: 4,
              hour: '',
              minute: ''
            }
          ]
        }
      ],
      houroptions: [], // 小时数组
      minutesoptions: [], // 分钟数组
      cycle: [
        {
          value: 1,
          label: '每天'
        },
        {
          value: 2,
          label: '每星期'
        },
        {
          value: 3,
          label: '每月'
        }
      ],
      weekarr: [
        {
          value: 1,
          label: '周一'
        },
        {
          value: 2,
          label: '周二'
        },
        {
          value: 3,
          label: '周三'
        },
        {
          value: 4,
          label: '周四'
        },
        {
          value: 5,
          label: '周五'
        },
        {
          value: 6,
          label: '周六'
        },
        {
          value: 7,
          label: '周日'
        }
      ],
      delayedarr: [
        {
          value: 1,
          label: '添加延时'
        },
        {
          value: 2,
          label: '关键字回复延时'
        }
      ],
      chooseindex: null,
      sendmsgdata: [],
      ids: null,
      type: null,
      loadingtable: false,
      messageindex: null,
      messageindexr: null,
      optionsrr: [
        {
          value: 0,
          label: '不限'
        },
        {
          value: 8,
          label: '24小时内'
        },
        {
          value: 1,
          label: '2天(48小时)以内'
        },
        {
          value: 2,
          label: '2天(48小时)前'
        },
        {
          value: 3,
          label: '2至7天'
        },
        {
          value: 4,
          label: '7天内'
        },
        {
          value: 5,
          label: '7天前'
        },
        {
          value: 6,
          label: '今天前'
        },
        {
          value: 9,
          label: '昨日'
        },
        {
          value: 7,
          label: '自定义'
        }
      ],
      optionspay: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '未付费'
        },
        {
          value: 2,
          label: '已付费'
        }
      ],
      subscribe_time_type: 0,
      subscribetime: [],
      subscribe_time_from: '',
      subscribe_time_to: '',
      messageload: false,
      consumption: 0, // 付费情况
      optionspayarr: [
        {
          value: 1,
          label: '全部'
        },
        {
          value: 2,
          label: '关注'
        },
        {
          value: 3,
          label: '取消关注'
        }
      ],
      // addFollow: 1,
      new_sp_strategy_no: '',
      biduigroup_selection: '',
      reuse: 2,
      trigger_way: 1,
      timing_interval: 0, // 单次时间间隔，最小 0 最大 100
      act_interval_min: 0, // 最小动作时间间隔，最小 0 最大 100
      act_interval_max: 0, // 最大动作时间间隔，最小 0 最大 100
      batch_size: 1, // 批次数量，最小 1 最大 100
      script_send_way: 1 // 默认选中1转发

    }
  },
  beforeDestroy() {
    console.log('this.$route.query.type:', this.$route.query.type, this.type)
    if (this.type === null) {
      console.log('进来了')
      if (!this.messageload) {
        const data = {
          sp_strategy_type: this.sp_strategy_type,
          sp_strategy_title: this.sp_strategy_title,
          group_selection: this.group_selection,
          push_method: this.push_method,
          subscribe_time_type: this.subscribe_time_type,
          msg_data: this.msg_data,
          subscribetime: this.subscribetime,
          cemsg_data: this.cemsg_data,
          script_send_way: this.script_send_way
        }
        window.localStorage.setItem('enterprisemilistmassageStorage', JSON.stringify(data))
      } else {
        window.localStorage.removeItem('enterprisemilistmassageStorage')
      }
    }
  },
  created() {
    const res = window.JSON.parse(window.localStorage.getItem('enterprisemilistmassageStorage') || '{}')
    console.log('this.$route.query.type:', this.$route.query.type)
    if (this.$route.query.type === undefined) {
      if (Object.keys(res).length !== 0) {
        this.sp_strategy_type = res.sp_strategy_type
        this.sp_strategy_title = res.sp_strategy_title
        this.group_selection = res.group_selection
        this.push_method = res.push_method
        this.subscribe_time_type = res.subscribe_time_type
        this.msg_data = res.msg_data
        this.subscribetime = res.subscribetime
        this.cemsg_data = res.cemsg_data
        this.script_send_way = res.script_send_way
      }
    }
    // eslint-disable-next-line eqeqeq
    if (JSON.stringify(this.$route.query) === '{}') {
      this.ids = null
      console.log('this.$route.query.type', this.$route.query.type)
    } else {
      this.ids = this.$route.query.id
      this.type = this.$route.query.type
      this.multiplexlist()
      console.log('this.$route.query.type', this.$route.query.type)
    }
    this.inittimearr(0, 23, this.houroptions)
    this.inittimearr(0, 59, this.minutesoptions)
  },
  mounted() {},
  methods: {
    copyReuse(item, i) {
      console.log('item, i:', item, i)
      // this.msg_data.push(item)
      this.msg_data.push(JSON.parse(JSON.stringify(item)))
      // this.msg_data.splice(i + 1, 0, JSON.parse(JSON.stringify(item)))
    },
    // 复用请求
    async multiplexlist() {
      this.loadingtable = true
      const data = await sprstrategystrategyInfo({
        sp_strategy_no: this.ids
      })
      this.sp_strategy_type = data.data.strategy.sp_strategy_type
      this.sp_strategy_title = data.data.strategy.sp_strategy_title
      this.group_selection = data.data.strategy.group_selection
      this.biduigroup_selection = data.data.strategy.group_selection
      this.push_method = data.data.strategy.push_method
      this.trigger_way = data.data.strategy.trigger_way
      this.timing_interval = data.data.strategy.timing_interval || 0
      this.act_interval_min = data.data.strategy.act_interval_min || 0
      this.act_interval_max = data.data.strategy.act_interval_max || 0
      this.batch_size = data.data.strategy.batch_size || 1
      this.script_send_way = data.data.strategy.script_send_way

      if (data.data.strategy.user_wheres === null) {
        this.subscribe_time_type = 0
      } else {
        this.consumption = data.data.strategy.user_wheres.consumption
        // this.addFollow = data.data.strategy.user_wheres.addFollow
        if (data.data.strategy.user_wheres.subscribe_time) {
          this.subscribe_time_type = data.data.strategy.user_wheres.subscribe_time.type
          if (data.data.strategy.user_wheres.subscribe_time.subscribe_time_range.length !== 0) {
            this.subscribe_time_from = data.data.strategy.user_wheres.subscribe_time.subscribe_time_range[0]
            this.subscribe_time_to = data.data.strategy.user_wheres.subscribe_time.subscribe_time_range[1]
            this.subscribetime = data.data.strategy.user_wheres.subscribe_time.subscribe_time_range
          }
        } else {
          this.subscribe_time_type = 0
        }
      }

      // this.subscribe_time_type = data.data.strategy.user_wheres.subscribe_time.type
      // this.subscribetime = data.data.strategy.user_wheres.subscribe_time.subscribe_time_range
      // this.subscribe_time_from = data.data.strategy.user_wheres.subscribe_time.subscribe_time_range[0]
      // this.subscribe_time_to = data.data.strategy.user_wheres.subscribe_time.subscribe_time_range[1]
      if (data.data.strategy.sp_strategy_type === 1) {
        this.msg_data = []
        this.msg_data = data.data.msg_data.map((itemr, indexrs) => {
          return { message_name: itemr.message_name, sp_message_no: itemr.sp_message_no, cycle_type: null, day_of_month: '', day_of_week: null, hour: '', minute: '', day_numbers: '' }
        })
      }
      if (data.data.strategy.sp_strategy_type === 2) {
        console.log('2222')
        this.msg_data = []
        this.msg_data = data.data.msg_data.map((itemr, indexrs) => {
          if (itemr.cycle_type === 1) {
            return { sp_message_no: itemr.sp_message_no, message_name: itemr.message_name, cycle_type: itemr.cycle_type, hour: itemr.hour, minute: itemr.minute, day_of_month: '', day_of_week: null, day_numbers: '' }
          }
          if (itemr.cycle_type === 2) {
            return { sp_message_no: itemr.sp_message_no, message_name: itemr.message_name, day_of_week: itemr.day_of_week, cycle_type: itemr.cycle_type, hour: itemr.hour, minute: itemr.minute, day_numbers: '', day_of_month: '' }
          }
          if (itemr.cycle_type === 3) {
            return { sp_message_no: itemr.sp_message_no, message_name: itemr.message_name, day_of_month: itemr.day_of_month, cycle_type: itemr.cycle_type, hour: itemr.hour, minute: itemr.minute, day_of_week: null, day_numbers: '' }
          }
        })
      }
      if (data.data.strategy.sp_strategy_type === 3) {
        // this.msg_data = []
        // this.msg_data = data.data.msg_data.map((itemr, indexrs) => {
        //   return { sp_message_no: itemr.sp_message_no, message_name: itemr.message_name, day_numbers: itemr.day_numbers, hour: itemr.hour, minute: itemr.minute, day_of_month: '',
        //     day_of_week: null, cycle_type: null }
        // })
        this.cemsg_data = []
        this.cemsg_data = data.data.msg_data
      }
      if (data.data.strategy.sp_strategy_type === 4) {
        this.msg_data = []
        this.msg_data = data.data.msg_data.map((itemr, indexrs) => {
          return { sp_message_no: itemr.sp_message_no, message_name: itemr.message_name, keyword: itemr.keyword }
        })
      }
      if (data.data.strategy.sp_strategy_type === 5) {
        this.msg_data = []
        this.msg_data = data.data.msg_data.map((itemr, indexrs) => {
          return { sp_message_no: itemr.sp_message_no, message_name: itemr.message_name, delay_type: itemr.delay_type, hours: itemr.hours, minutes: itemr.minutes, seconds: itemr.seconds, delay_keyword: itemr.delay_keyword }
        })
      }
      if (data.data.strategy.sp_strategy_type === 6) {
        this.msg_data = []
        this.msg_data = data.data.msg_data.map((itemr, indexrs) => {
          return { message_name: itemr.message_name, sp_message_no: itemr.sp_message_no, cycle_type: null, day_of_month: '', day_of_week: null, hour: '', minute: '', day_numbers: '' }
        })
      }
      this.loadingtable = false
      console.log('data', data)
    },
    // 初始化时分秒
    inittimearr(valone, valtwo, arr) {
      for (let i = valone; i <= valtwo; i++) {
        arr.push({
          value: i,
          label: `${i}`
        })
      }
    },
    copy() {
      this.msg_data.push({
        cycle_type: null, // 时长类型
        day_of_month: '', // 几日
        day_of_week: null, // 每星期
        sp_message_no: '', // 选择的消息
        message_name: '', // 选择的消息名称
        hour: '', // 小时
        minute: '', // 分钟
        day_numbers: '', // 第几天
        keyword: '', // 关键词
        hours: '', // 延时小时
        minutes: '', // 延时分钟
        seconds: '', // 延时描述
        delay_type: null, // 延时类型
        delay_keyword: '' // 延时关键字
      })
    },
    chooser(index) {
      this.chooseindex = index
      this.dialogVisible = true
      console.log('push_method', this.push_method)
      console.log('this.type', this.type)
      this.$nextTick(() => {
        this.$refs.choosetacticsview.send(1, this.push_method, this.type, this.ids)
      })
    },
    chooserr(index, indexr) {
      this.messageindex = index
      this.messageindexr = indexr
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosetacticsview.send(2)
      })
    },
    dayewr(index) {
      // eslint-disable-next-line eqeqeq
      if (this.msg_data[index].day_of_month < 1 && this.msg_data[index].day_of_month != '') {
        this.msg_data[index].day_of_month = 1
      }
      // 判断不能输入小数点
      const str = '' + this.msg_data[index].day_of_month
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.msg_data[index].day_of_month = 0
      }
      if (this.msg_data[index].day_of_month > 31) {
        this.msg_data[index].day_of_month = 31
      }
    },
    timedayewr(index) {
      // eslint-disable-next-line eqeqeq
      if (this.msg_data[index].day_numbers < 1 && this.msg_data[index].day_numbers != '') {
        this.msg_data[index].day_numbers = 1
      }
      // 判断不能输入小数点
      const str = '' + this.msg_data[index].day_numbers
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.msg_data[index].day_numbers = 0
      }
      if (this.msg_data[index].day_numbers > 60) {
        this.msg_data[index].day_numbers = 60
      }
    },
    implement(item) {
      if (item.cycle_type === 1) {
        item.day_of_week = null
        item.day_of_month = ''
      } else if (item.cycle_type === 2) {
        item.day_of_month = ''
      } else {
        item.day_of_week = null
      }
    },
    deleter(index) {
      this.msg_data.splice(index, 1)
    },
    deleterr(index) {
      this.cemsg_data.splice(index, 1)
    },
    callback(item) {
      this.dialogVisible = false
      this.msg_data[this.chooseindex].sp_message_no = item.sp_message_no
      this.msg_data[this.chooseindex].message_name = item.title
      console.log(item)
    },
    callbackr(item) {
      this.dialogVisible = false
      this.cemsg_data[this.messageindex].messages[this.messageindexr].sp_message_no = item.sp_message_no
      this.cemsg_data[this.messageindex].messages[this.messageindexr].title = item.title
      // this.msg_data[this.chooseindex].sp_message_no = item.sp_message_no
      // this.msg_data[this.chooseindex].message_name = item.title
      console.log(item)
    },
    spchanger(val) {
      console.log(val)
      if (val === 1) {
        this.group_selection = 1
        this.push_method = 1
        this.subscribe_time_type = 0
        this.consumption = 0
        // this.addFollow = 1
        this.trigger_way = 1
      }
      if (val === 2) {
        console.log('111', this.msg_data)
        if (this.group_selection === 6) {
          this.push_method = 1
          this.trigger_way = 2
        }
      }
      if (val === 4) {
        this.group_selection = 1
        this.push_method = 2
        this.subscribe_time_type = 0
        this.consumption = 0
        // this.addFollow = 1
        this.trigger_way = 1
      }
      if (val === 5) {
        this.group_selection = 1
        this.push_method = 2
        this.subscribe_time_type = 0
        this.consumption = 0
        // this.addFollow = 1
        this.trigger_way = 1
      }
      if (val === 6) {
        this.group_selection = 5
        this.push_method = 2
        this.trigger_way = 1
      }
      this.msg_data.forEach(item => {
        item.message_name = ''
        item.sp_message_no = ''
      })
    },
    spchangerr() {
      this.msg_data.forEach(item => {
        item.message_name = ''
        item.sp_message_no = ''
      })
      if (this.push_method === 1) {
        this.trigger_way = 2
      }
      if (this.push_method === 2) {
        this.trigger_way = 1
      }
    },
    async saveclick() {
      // 构造基本参数
      const payload = {
        // sp_strategy_type: this.sp_strategy_type,
        // sp_strategy_title: this.sp_strategy_title,
        // group_selection: this.group_selection,
        // push_method: this.push_method,
        // msg_data:
        //   this.sp_strategy_type === 3 ? this.cemsg_data : this.sendmsgdata,
        // subscribe_time_type: this.subscribe_time_type,
        // consumption: this.consumption,
        // trigger_way: this.trigger_way
      }

      if (
        this.sp_strategy_type === 2 &&
        this.push_method === 2 &&
        this.trigger_way === 2 &&
        [1, 3, 5].includes(this.group_selection)
      ) {
        payload.timing_interval = this.timing_interval
        payload.act_interval_min = this.act_interval_min
        payload.act_interval_max = this.act_interval_max
        payload.batch_size = this.batch_size
        payload.script_send_way = this.script_send_way
      }

      if (this.sp_strategy_title === '') {
        this.$message.error('请填写策略标题')
        return
      }

      if (this.trigger_way !== 1 && !this.script_send_way) {
        this.$message.error('请选择企微脚本定时发送方式')
        return
      }

      if (this.sp_strategy_type === 1) {
        if (this.msg_data[0].sp_message_no === '') {
          this.$message.error('请选择消息')
          return
        }
      } else {
        // const boolthree = this.msg_data.every((item, index, array) => {
        //   return item.sp_message_no !== ''
        // })
        // if (boolthree === false) {
        //   this.$message.error('请选择消息')
        //   return
        // }
        if (this.sp_strategy_type === 2 || this.sp_strategy_type === 4) {
          for (let i = 0; i < this.msg_data.length; i++) {
            if (this.msg_data[i].sp_message_no === '') {
              this.$message.error(`请选择第${i + 1}条消息`)
              return
            }
          }
        }
      }
      if (this.sp_strategy_type === 2) {
        // const cycle_typebool = this.msg_data.every((item, index, array) => {
        //   return item.cycle_type !== null
        // })
        // if (cycle_typebool === false) {
        //   this.$message.error('请选择时长类型')
        //   return
        // }
        if (this.subscribe_time_type === 7) {
          if (this.subscribetime.length === 0) {
            this.$message.error('请选择自定义时间范围')
            return
          }
        }
        for (let i = 0; i < this.msg_data.length; i++) {
          if (this.msg_data[i].cycle_type === null) {
            this.$message.error(`请选择第${i + 1}条消息时长类型`)
            return
          }
        }
        const arrs = []
        this.msg_data.forEach(item => {
          if (item.cycle_type === 2) {
            arrs.push({
              cycle_type: item.cycle_type,
              day_of_week: item.day_of_week
            })
          }
        })
        // const week_typebool = arrs.every((item, index, array) => {
        //   return item.day_of_week !== null
        // })
        // if (week_typebool === false) {
        //   this.$message.error('请选择星期数')
        //   return
        // }
        for (let i = 0; i < arrs.length; i++) {
          if (arrs[i].day_of_week === null) {
            this.$message.error(`请选择第${i + 1}条消息星期数`)
            return
          }
        }
        const arrsr = []
        this.msg_data.forEach(item => {
          if (item.cycle_type === 3) {
            arrsr.push({
              cycle_type: item.cycle_type,
              day_of_month: item.day_of_month
            })
          }
        })
        // const month_typebool = arrsr.every((item, index, array) => {
        //   return item.day_of_month !== ''
        // })
        // if (month_typebool === false) {
        //   this.$message.error('请选择几日')
        //   return
        // }
        for (let i = 0; i < arrsr.length; i++) {
          if (arrsr[i].day_of_month === '') {
            this.$message.error(`请选择第${i + 1}条消息几日`)
            return
          }
        }

        // const hour_typebool = this.msg_data.every((item, index, array) => {
        //   return item.hour !== ''
        // })
        // if (hour_typebool === false) {
        //   this.$message.error('请选择小时数')
        //   return
        // }
        for (let i = 0; i < this.msg_data.length; i++) {
          if (this.msg_data[i].hour === '') {
            this.$message.error(`请选择第${i + 1}条消息小时数`)
            return
          }
        }
        // const minute_typebool = this.msg_data.every((item, index, array) => {
        //   return item.minute !== ''
        // })
        // if (minute_typebool === false) {
        //   this.$message.error('请选择分钟数')
        //   return
        // }
        for (let i = 0; i < this.msg_data.length; i++) {
          if (this.msg_data[i].minute === '') {
            this.$message.error(`请选择第${i + 1}条消息分钟数`)
            return
          }
        }
      }
      if (this.sp_strategy_type === 3) {
        for (let i = 0; i < this.cemsg_data.length; i++) {
          if (this.cemsg_data[i].day_numbers === '') {
            this.$message.error(`请填写第${i + 1}条消息天数`)
            return
          }
        }
        for (let i = 0; i < this.cemsg_data.length; i++) {
          for (let k = 0; k < this.cemsg_data[i].messages.length; k++) {
            if (this.cemsg_data[i].messages[k].hour === '') {
              this.$message.error(`请填写第${i + 1}条消息中的第${k + 1}个小时数`)
              return
            }
            if (this.cemsg_data[i].messages[k].minute === '') {
              this.$message.error(`请填写第${i + 1}条消息中的第${k + 1}个分钟数`)
              return
            }
            if (this.cemsg_data[i].messages[k].sp_message_no === '') {
              this.$message.error(`请选择第${i + 1}条消息`)
              return
            }
          }
        }
      }
      if (this.sp_strategy_type === 4) {
        for (let i = 0; i < this.msg_data.length; i++) {
          if (this.msg_data[i].keyword === '') {
            this.$message.error(`请输入第${i + 1}条消息的关键词`)
            return
          }
        }
      }
      if (this.sp_strategy_type === 5) {
        for (let i = 0; i < this.msg_data.length; i++) {
          if (this.msg_data[i].hours === '') {
            this.$message.error(`请选择第${i + 1}条消息小时数`)
            return
          }
          if (this.msg_data[i].minutes === '') {
            this.$message.error(`请选择第${i + 1}条消息分钟数`)
            return
          }
          if (this.msg_data[i].seconds === '') {
            this.$message.error(`请选择第${i + 1}条消息秒数`)
            return
          }
          if (this.msg_data[i].delay_type === null) {
            this.$message.error(`请选择第${i + 1}条消息延时动作`)
            return
          }
          if (this.msg_data[i].delay_type === 2) {
            if (this.msg_data[i].delay_keyword === '') {
              this.$message.error(`请选择第${i + 1}条消息关键字`)
              return
            }
          }
          if (this.msg_data[i].sp_message_no === '') {
            this.$message.error(`请选择第${i + 1}条消息`)
            return
          }
        }
      }
      if (this.sp_strategy_type === 6) {
        if (this.msg_data[0].sp_message_no === '') {
          this.$message.error('请选择消息')
          return
        }
      }
      this.sendmsgdata = []
      // eslint-disable-next-line eqeqeq
      if (this.sp_strategy_type === 1) {
        this.sendmsgdata.push({
          sp_message_no: this.msg_data[0].sp_message_no
        })
      }
      // eslint-disable-next-line eqeqeq
      if (this.sp_strategy_type === 2) {
        this.sendmsgdata = this.msg_data.map((itemr, indexrs) => {
          // eslint-disable-next-line eqeqeq
          if (itemr.cycle_type === 1) {
            return { sp_message_no: itemr.sp_message_no, cycle_type: itemr.cycle_type, hour: itemr.hour, minute: itemr.minute }
          }
          if (itemr.cycle_type === 2) {
            return { sp_message_no: itemr.sp_message_no, day_of_week: itemr.day_of_week, cycle_type: itemr.cycle_type, hour: itemr.hour, minute: itemr.minute }
          }
          if (itemr.cycle_type === 3) {
            return { sp_message_no: itemr.sp_message_no, day_of_month: itemr.day_of_month, cycle_type: itemr.cycle_type, hour: itemr.hour, minute: itemr.minute }
          }
        })
      }
      // eslint-disable-next-line eqeqeq
      if (this.sp_strategy_type === 4) {
        this.sendmsgdata = this.msg_data.map((itemr, indexrs) => {
          return { sp_message_no: itemr.sp_message_no, keyword: itemr.keyword }
        })
      }
      // eslint-disable-next-line eqeqeq
      if (this.sp_strategy_type === 5) {
        this.sendmsgdata = this.msg_data.map((itemr, indexrs) => {
          return { sp_message_no: itemr.sp_message_no, hours: itemr.hours, minutes: itemr.minutes, seconds: itemr.seconds, delay_type: itemr.delay_type, delay_keyword: itemr.delay_keyword }
        })
      }
      // eslint-disable-next-line eqeqeq
      if (this.sp_strategy_type === 6) {
        this.sendmsgdata.push({
          sp_message_no: this.msg_data[0].sp_message_no
        })
      }
      // // eslint-disable-next-line eqeqeq
      // if (this.sp_strategy_type === 3) {
      //   this.sendmsgdata = this.msg_data.map((itemr, indexrs) => {
      //   // eslint-disable-next-line eqeqeq
      //     return { sp_message_no: itemr.sp_message_no, day_numbers: itemr.day_numbers, hour: itemr.hour, minute: itemr.minute }
      //   })
      // }
      console.log(this.sendmsgdata)
      // eslint-disable-next-line eqeqeq
      if (this.type === 2) {
        console.log('编辑')
        const obj = {}
        if (this.subscribe_time_type === 7) {
          obj.subscribe_time_from = this.subscribe_time_from
          obj.subscribe_time_to = this.subscribe_time_to
        }
        const data = await sprstrategyupdate({
          sp_strategy_type: this.sp_strategy_type,
          sp_strategy_title: this.sp_strategy_title,
          group_selection: this.group_selection,
          sp_strategy_no: this.ids,
          ...payload,
          push_method: this.push_method,
          msg_data: this.sp_strategy_type === 3 ? this.cemsg_data : this.sendmsgdata,
          subscribe_time_type: this.subscribe_time_type,
          script_send_way: this.script_send_way,
          ...obj,
          consumption: this.consumption,
          // addFollow: this.addFollow,
          trigger_way: this.trigger_way
        })
        console.log('data', data)
        this.$router.push({
          path: '/enterprisemilist/index'
        })
      } else {
        const obj = {}
        if (this.subscribe_time_type === 7) {
          obj.subscribe_time_from = this.subscribe_time_from
          obj.subscribe_time_to = this.subscribe_time_to
        }
        const obrbox = {}
        if (this.type === 3) {
          obrbox.sp_strategy_no = this.$route.query.id
          obrbox.reuse = this.reuse
        }
        const data = await sprstrategystore({
          sp_strategy_type: this.sp_strategy_type,
          sp_strategy_title: this.sp_strategy_title,
          group_selection: this.group_selection,
          push_method: this.push_method,
          msg_data: this.sp_strategy_type === 3 ? this.cemsg_data : this.sendmsgdata,
          subscribe_time_type: this.subscribe_time_type,
          script_send_way: this.script_send_way,
          ...obj,
          consumption: this.consumption,
          // addFollow: this.addFollow,
          ...payload,
          ...obrbox,
          trigger_way: this.trigger_way
        })
        // this.$router.push({
        //   path: '/enterprisemilist/index'
        // })
        this.$router.go(-1)
        // if (this.type === 3 && this.biduigroup_selection === this.group_selection) {
        //   this.new_sp_strategy_no = data.data.sp_strategy_no
        //   this.$confirm('是否立即绑定员工/群/群规则', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   })
        //     .then(() => {
        //       strategyreuseBind({
        //         sp_strategy_no: this.ids,
        //         new_sp_strategy_no: this.new_sp_strategy_no
        //       }).then(res => {
        //         this.$message({
        //           type: 'success',
        //           message: '绑定成功!'
        //         })
        //         this.$router.go(-1)
        //       })
        //     })
        //     .catch(() => {
        //       this.$router.go(-1)
        //     })
        // } else {
        //   console.log('新增')
        //   this.$router.go(-1)
        // }
        console.log('data', data)
      }
      this.messageload = true
    },
    goback() {
      this.$router.go(-1)
    },
    async look(id) {
      const data = await sprEnterprise({
        sp_message_no: id
      })
      console.log('data', data.data)
      this.priwdialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(data.data)
      }, 100)
    },
    copycirculate() {
      this.cemsg_data.push({
        day_numbers: '',
        messages: [
          {
            sp_message_no: '',
            title: '',
            cycle_type: 4,
            hour: '',
            minute: ''
          }
        ]
      })
    },
    addmdssagecirculate(index) {
      this.cemsg_data[index].messages.push({
        sp_message_no: '',
        title: '',
        cycle_type: 4,
        hour: '',
        minute: ''
      })
    },
    deletercirculate(index, indexr) {
      this.cemsg_data[index].messages.splice(indexr, 1)
    },
    sendmatgser(val) {
      console.log(val)
      if (val === 3) {
        this.push_method = 2
      }
      if (val === 4) {
        this.push_method = 1
      }
      if (val === 5) {
        this.push_method = 2
      }
      if (val === 6 && this.sp_strategy_type === 2) {
        this.push_method = 1
        this.trigger_way = 2
      }
      this.msg_data.forEach(item => {
        item.message_name = ''
        item.sp_message_no = ''
      })
    },
    delayecahegr(val, item) {
      console.log('2222', val, item)
      if (val === 1) {
        item.delay_keyword = ''
      }
    },
    timechanger(val) {
      this.subscribe_time_from = val[0]
      this.subscribe_time_to = val[1]
      console.log('val', val)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tactics_box {
  display:flex;
  align-items:center;
  justify-content:center;
  flex-direction:column;
  padding: 40px 0px;
}
.basic-box{
  min-width:1200px;
  width:1200px;
  padding:20px 100px;
}
.basic-box div{
  justify-content: space-between;
}
.basic-box div .el-form-item{
  width:50%;
  margin-bottom:24px !important;
}
.stra_box {
  width: 300px;
}
.copy_box {
  display: flex;
  margin-bottom:10px;
  align-items: center;
}
.copy_boxr {
  display: flex;
  align-items: center;
  position:relative;
}
.taewr {
  display: flex;
  align-items: center;
}
.tiwmebox {
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  border-left: 0px;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 0px 5px 5px 0px;
}
.tiwmeboxr {
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 5px;
}
.ca_boxr {
  margin-right: 0px;
  width: 50px;
  text-align: right;
  color: #666;
  font-size: 14px;
  margin-top:10px;
  left:60px;
}
.ca_boxre {
  width: 50px;
  text-align: right;
  margin-right: 16px;
  color: #666;
  font-size: 14px;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield !important;
}

.sum_box {
  position: fixed;
  left: 0;
  bottom: -20px;
  margin-left: 30px;
}
.message-box{
  position:relative;
  min-width:1200px;
  width:1200px;
  padding:20px 100px;
}
.add-btn{
  position:absolute;
  top:-40px;
  right:0
}
.sava_box {
  margin-top:100px;
}
.caserr_box {
  /* height: 200px;
      overflow: hidden;
      overflow-y: scroll; */
}
.senadtime {
  display: flex;
  align-items: center;
}
.adds-box{
  display:flex;
  width:90%;
  /* justify-content: flex-start !important; */
}
.adds-box div{
    width:400px !important;
  }
  @media (max-width: 768px){
    .tactics_box{
      width:100%;
    }
    .basic-box,.message-box{
      min-width:100% !important;
      width:100%;
      padding:5vw;
    }
    .basic-box,.basic-box div{
      flex-direction:column;
    }
    .el-form-item{
      padding-top:4vw;
    }
    .basic-box div .el-form-item{
      width:100% !important;
    }
    .add-btn{
      right:5vw;
    }
    .basic-box div{
      width:100%;
    }
    .copy_box button{
      margin:2vw 1vw;
    }
  }
</style>
